import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const Styles = styled.div`
  .nav {
    display: inline-block;
    border-radius: 5px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    margin-bottom: 35px;
    .nav-item {
      display: inline-block;
      a.nav-link {
        font-size: 14px;
        color: ${colors.black2};
        font-weight: 500;
        text-transform: uppercase;
        padding: 12px 30px 10px;
        border-radius: 5px;

        @media (max-width: 991px) {
          padding: 12px 16px 9px;
        }
      }
      a.nav-link.active {
        background: ${colors.grBg};
        color: #ffffff;
      }
    }
  }
  .overview-tab {
    h1,
    h2,
    h3,
    h4,
    h5 {
      color: ${colors.black2};
      font-weight: 600;
      padding-bottom: 10px;
      margin-bottom: 20px;
      position: relative;
      &:before {
        position: absolute;
        content: '';
        background: ${colors.blue2};
        width: 50px;
        height: 2px;
        bottom: 0;
        left: 0;
      }
      &:not(:first-child) {
        margin-top: 24px;
      }

      @media (max-width: 575px) {
        font-size: 17px;
      }
    }
    .text-content {
      p {
        font-size: 15px;
        color: ${colors.text2};
        line-height: 25px;

        @media (max-width: 575px) {
          font-size: 14px;
        }
      }
      margin-bottom: 40px;
      ul {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        gap: 0;
        li {
          list-style: none;
          font-size: 14px;
          color: ${colors.text3};
          i {
            font-size: 20px;
            color: ${colors.blue2};
            float: left;
            height: 30px;
            margin-right: 10px;
            margin-left: 0;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .course-share {
      ul.social {
        margin-top: 30px;
        li {
          a {
            text-align: center;
            position: relative;
            height: 18px;
            display: inline-block;

            &:before {
              content: '';
              position: absolute;
              border-width: 9px 17px;
              border-style: solid;
              border-top-color: transparent;
              border-right-color: transparent;
              border-left-color: transparent;
              top: -18px;
              left: 0;
              z-index: 1;
              transition: all 0.2s ease;
            }

            &:after {
              content: '';
              position: absolute;
              border-width: 9px 17px;
              border-style: solid;
              border-right-color: transparent;
              border-bottom-color: transparent;
              border-left-color: transparent;
              bottom: -18px;
              left: 0;
              z-index: 1;
              transition: all 0.2s ease;
            }

            i {
              font-size: 14px;
              color: #ffffff;
              width: 34px;
            }

            &:hover {
              background-color: ${colors.blue2} !important;

              &:before {
                border-bottom-color: ${colors.blue2} !important;
              }

              &:after {
                border-top-color: ${colors.blue2} !important;
              }
            }
          }

          &:nth-child(1) {
            a {
              background-color: #4267b2;

              &:before {
                border-bottom-color: #4267b2;
              }

              &:after {
                border-top-color: #4267b2;
              }
            }
          }

          &:nth-child(2) {
            a {
              background-color: #2867b2;

              &:before {
                border-bottom-color: #2867b2;
              }

              &:after {
                border-top-color: #2867b2;
              }
            }
          }

          &:nth-child(3) {
            a {
              background-color: #dd1343;

              &:before {
                border-bottom-color: #dd1343;
              }

              &:after {
                border-top-color: #dd1343;
              }
            }
          }
        }
      }
    }
  }
  .curriculum-tab {
    .course-curriculum {
      margin-bottom: 40px;
      h1,
      h2,
      h3,
      h4,
      h5 {
        color: ${colors.black2};
        font-weight: 600;
        padding-bottom: 10px;
        margin-bottom: 20px;
        position: relative;
        &:before {
          position: absolute;
          content: '';
          background: ${colors.blue2};
          width: 50px;
          height: 2px;
          bottom: 0;
          left: 0;
        }

        @media (max-width: 575px) {
          font-size: 17px;
        }
      }
      p {
        font-size: 15px;
        color: ${colors.text2};
        line-height: 25px;

        @media (max-width: 575px) {
          font-size: 14px;
        }
      }
    }
    .course-element {
      h2 {
        color: ${colors.black2};
        font-weight: 600;
        padding-bottom: 10px;
        margin-bottom: 20px;
        position: relative;
        &:before {
          position: absolute;
          content: '';
          background: ${colors.blue2};
          width: 50px;
          height: 2px;
          bottom: 0;
          left: 0;
        }

        @media (max-width: 575px) {
          font-size: 17px;
        }
      }
      .course-item {
        margin-bottom: 10px;
        button.course-button {
          border: none;
          background: transparent;
          margin-bottom: 15px;
          display: block;
          width: 100%;
          text-align: left;
          padding: 0;
          font-size: 18px;
          color: ${colors.black2};
          font-weight: 500;
          span {
            float: right;
            font-size: 14px;
            color: ${colors.text3};
            font-weight: 400;
          }
        }

        .course-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.2s ease-in-out;
          ul {
            li {
              border-bottom: 1px solid ${colors.border3};
              margin-left: 25px;
              padding: 12px 0;
              span.play-icon {
                font-size: 14px;
                color: ${colors.text3};
                margin-right: 20px;
                i {
                  color: ${colors.blue2};
                  border: 1px solid ${colors.blue2};
                  font-size: 22px;
                  height: 30px;
                  border-radius: 50%;
                  padding-left: 3px;
                  padding-right: 3px;
                  text-align: center;
                  line-height: 29px;
                  vertical-align: middle;
                }
              }
              span.lecture-title {
                font-size: 15px;
                color: ${colors.black2};

                @media (max-width: 575px) {
                  font-size: 14px;
                }
              }
              span.lecture-duration {
                float: right;
                font-size: 14px;
                color: ${colors.text3};
                line-height: 28px;
                font-weight: 400;
              }
            }
          }
        }

        .course-content.show {
          max-height: 100%;
          margin-bottom: 40px;
        }

        &:last-child {
          margin-bottom: 40px;
        }
      }
    }
  }
  .instructor-tab {
    h1,
    h2,
    h3,
    h4,
    h5 {
      color: ${colors.black2};
      font-weight: 600;
      padding-bottom: 10px;
      margin-bottom: 35px;
      position: relative;
      &:before {
        position: absolute;
        content: '';
        background: ${colors.blue2};
        width: 50px;
        height: 2px;
        bottom: 0;
        left: 0;
      }

      @media (max-width: 575px) {
        font-size: 17px;
      }
    }

    .instructor-item {
      margin-bottom: 30px;

      .instructor-img {
        img {
          border-radius: 5px;
        }
      }

      .instructor-content {
        position: relative;

        .instructor-box {
          box-shadow: 0 0px 20px rgba(0, 0, 0, 0.08);
          padding: 25px;
          background: #ffffff;
          border-radius: 5px;
          position: absolute;
          top: 32px;
          left: -11%;
          z-index: 1;

          .top-content {
            margin-bottom: 20px;

            .instructor-name {
              h6 {
                color: ${colors.black2};
                font-weight: 600;
                text-transform: uppercase;
                margin-bottom: 12px;

                @media (max-width: 575px) {
                  font-size: 14px;
                }
              }
              p {
                font-size: 14px;
                color: ${colors.text3};
                font-weight: 500;
              }
            }
            .instructor-social {
              margin-top: 25px;
              ul.social {
                li {
                  a {
                    text-align: center;
                    position: relative;

                    &:before {
                      content: '';
                      position: absolute;
                      border-width: 8px 14px;
                      border-style: solid;
                      border-top-color: transparent;
                      border-right-color: transparent;
                      border-left-color: transparent;
                      top: -16px;
                      left: 0;
                      z-index: 1;
                      transition: all 0.2s ease;
                    }

                    &:after {
                      content: '';
                      position: absolute;
                      border-width: 8px 14px;
                      border-style: solid;
                      border-right-color: transparent;
                      border-bottom-color: transparent;
                      border-left-color: transparent;
                      bottom: -16px;
                      left: 0;
                      z-index: 1;
                      transition: all 0.2s ease;
                    }

                    i {
                      font-size: 13px;
                      color: #ffffff;
                      width: 28px;
                    }

                    &:hover {
                      background-color: ${colors.blue2} !important;

                      &:before {
                        border-bottom-color: ${colors.blue2} !important;
                      }

                      &:after {
                        border-top-color: ${colors.blue2} !important;
                      }
                    }
                  }

                  &:nth-child(1) {
                    a {
                      background-color: #4267b2;

                      &:before {
                        border-bottom-color: #4267b2;
                      }

                      &:after {
                        border-top-color: #4267b2;
                      }
                    }
                  }

                  &:nth-child(2) {
                    a {
                      background-color: #1da1f2;

                      &:before {
                        border-bottom-color: #1da1f2;
                      }

                      &:after {
                        border-top-color: #1da1f2;
                      }
                    }
                  }

                  &:nth-child(3) {
                    a {
                      background-color: #2867b2;

                      &:before {
                        border-bottom-color: #2867b2;
                      }

                      &:after {
                        border-top-color: #2867b2;
                      }
                    }
                  }

                  &:nth-child(4) {
                    a {
                      background-color: #dd1343;

                      &:before {
                        border-bottom-color: #dd1343;
                      }

                      &:after {
                        border-top-color: #dd1343;
                      }
                    }
                  }
                }
              }
            }
          }

          .instructor-desk {
            p {
              font-size: 15px;
              color: ${colors.text2};
              line-height: 25px;

              @media (max-width: 575px) {
                font-size: 14px;
              }
            }
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
